import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import { ContractDocumentPreview, type ContractDocumentPreviewProps } from './ContractDocumentPreview';

interface ContractPreviewModalProps {
  title: string;
  subtitle?: string;
  preview: ContractDocumentPreviewProps;
  onClose: () => void;
}

/**
 * "Förhandsgranska" for a contract the wizards cannot open (e.g. signed outside
 * the signing service, or signed by one party only): the same document as the
 * wizard's review, read-only and without signing.
 */
export function ContractPreviewModal({ title, subtitle, preview, onClose }: ContractPreviewModalProps) {
  const { t } = useTranslation();
  return (
    <Modal
      title={title}
      onClose={onClose}
      size="xl"
      fullscreenBelow="md"
      dialogClassName="contract-wizard-dialog"
      closeAriaLabel={t('common.close')}
      subheader={subtitle ? <div className="contract-wizard-subheader"><p className="contract-wizard-subtitle">{subtitle}</p></div> : undefined}
      footer={
        <div className="contract-wizard-footer">
          <div className="contract-wizard-footer-secondary">
            <button type="button" className="btn contract-wizard-btn-outline flex-fill flex-md-grow-0" onClick={onClose}>
              {t('common.close')}
            </button>
          </div>
        </div>
      }
    >
      <div className="contract-wizard-body">
        <div className="contract-wizard-main" data-testid="contract-preview-readonly">
          <ContractDocumentPreview {...preview} />
        </div>
      </div>
    </Modal>
  );
}

export default ContractPreviewModal;
